import * as React from 'react'
import styled from 'styled-components'
import { ReactComponent as HeartIcon } from 'assets/snackableTeaser/like-outlineWithoutSize.svg'
import { ReactComponent as WarningIcon } from 'assets/snackableTeaser/warningWS.svg'
import { ReactComponent as NotificationIcon } from 'assets/snackableTeaser/notificationWS.svg'
import { ReactComponent as DiscountIcon } from 'assets/snackableTeaser/discountWS.svg'
import { ReactComponent as ReleaseIcon } from 'assets/snackableTeaser/new-releaseWS.svg'
import { ReactComponent as SaleIcon } from 'assets/snackableTeaser/sellWS.svg'
import { ReactComponent as NewsIcon } from 'assets/snackableTeaser/campaignWS.svg'
import { ReactComponent as MailIcon } from 'assets/snackableTeaser/mailWS.svg'

type Props = {
  icon: string
  className?: string
}

// Define a dictionary to map icon names to their respective components
const iconDict: { [key: string]: React.ComponentType } = {
  heartoutline: HeartIcon,
  warning: WarningIcon,
  notification: NotificationIcon,
  discount: DiscountIcon,
  release: ReleaseIcon,
  sale: SaleIcon,
  news: NewsIcon,
  mail: MailIcon
}

export default function IconDisplayer(props: Props) {
  const { icon, className } = props

  // Get the component from the dictionary based on the icon name,
  // or use a default icon if the icon name is not recognized
  const IconComponent = iconDict[icon] || HeartIcon

  return (
    <StyledIconWrapper className={className}>
      <IconComponent />
    </StyledIconWrapper>
  )
}

const StyledIconWrapper = styled.div`
  
  svg {
    width: 100%;
    height: 100%;
  }
`
